import { HTTP as http } from '../../http'

const PREFIX = '/modules'

export default {
    index() {
        return http.get(PREFIX)
    }
}
